// extracted by mini-css-extract-plugin
module.exports = {"root":"ClientComment_root__2X2vx"};